import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { getLabels, GRID_PAGE_SIZE } from '../constant/deallocate-students';
import { DEALLOCATE_STUDENTS_TABLE_HEADERS as TABLE_HEADERS } from '../constant/deallocate-students';
import ConfirmationDialog from './ConfirmationDialog';
import DeallocateStudentActions from './DeallocateStudentActions';
import NoRowsDeallocation from './NoRowsDeallocation';
import MultiSelectFooter from './MultiSelectFooter';
import { ReactComponent as Sort } from '../../../../../assets/img/svg/sort.svg';
import { ReactComponent as SortDesc } from '../../../../../assets/img/svg/sortDesc.svg';
import { useHistory } from 'react-router';

const StudentList = ({ rowsData, rowCount, page, onPageChange, deallocateStudentHandler, batchName }) => {
  const history = useHistory();

  const dropdowns = useSelector(state => state.deallocateStudents.dropdowns)

  const [openDeallocationDialog, setOpenDeallocationDialog] = useState(false);
  const [studentId, setStudentId] = useState();
  const [selectionModel, setSelectionModel] = useState([]);
  const [isMultiDeallocate, setIsMultiDeallocate] = useState(false);
  // const [dialogType, setDialogType] = useState('deallocate');

  const isRowSelectable = (params) => {
    // if (selectionModel.length >= availableForSelection) {
    //   if (selectionModel.includes(params.id)) return true;
    //   else return false;
    // }
    return true;
  }

  const StudentListHeader = [
    { field: 'psid', headerName: TABLE_HEADERS.PSID, minWidth: 100, flex: 1, renderCell: (params) => <strong className='color-primary cursor' onClick={() => window.open(history.createHref({ pathname: `admin/edp/studentDetails/${params?.value}` }), '_blank')}>{params.value}</strong> },
    { field: 'applicationId', headerName: TABLE_HEADERS.APPLICATION_NO, minWidth: 150, flex: 1 },
    { field: 'studentName', headerName: TABLE_HEADERS.STUDENT_NAME, minWidth: 200, flex: 1 },
    { field: 'registrationDate', headerName: TABLE_HEADERS.REGISTRATION_DATE, minWidth: 150, flex: 1, renderCell: (params) => <span>{params?.value ? moment(params.value).format('DD-MM-YYYY') : '-'}</span> },
    { field: 'termDispVal', headerName: TABLE_HEADERS.TERM, minWidth: 150, flex: 1, valueGetter: params => params?.value ?? '-' },
    { field: 'courseId', headerName: TABLE_HEADERS.COURSE, minWidth: 150, flex: 1 },
    { field: 'businessArea', headerName: TABLE_HEADERS.BUSINESS_AREA, minWidth: 150, flex: 1, valueGetter: (params) => getLabels(dropdowns?.businessArea?.all, params.value) },
    { field: 'programAction', headerName: TABLE_HEADERS.PROGRAM_PLAN, minWidth: 150, flex: 1 },
    { field: 'Actions', headerName: 'Actions', type: 'actions', minWidth: 150, flex: 1, filterable: false, sortable: false, renderCell: (params) => <DeallocateStudentActions row={params.row} setOpenDialog={setOpenDeallocationDialog} setId={setStudentId} /> },
  ]

  return (
    <div className='mt-3' style={{ minHeight: 370, flexGrow: 1, display: 'flex', flexFlow: 'column' }}>
      <DataGrid
        rows={rowsData}
        columns={StudentListHeader}
        getRowId={(row) => row.applicationId}
        checkboxSelection={true}
        density={"compact"}
        rowHeight={44}
        getRowHeight={(params) => 44}
        headerHeight={56}
        pagination
        pageSize={GRID_PAGE_SIZE}
        rowsPerPageOptions={[GRID_PAGE_SIZE]}
        paginationMode={"server"}
        page={page}
        onPageChange={(e) => onPageChange(e)}
        disableColumnMenu
        loading={false}
        components={{
          ColumnSortedDescendingIcon: SortDesc,
          ColumnSortedAscendingIcon: Sort,
          // LoadingOverlay: () => <ALoader />
          NoRowsOverlay : () => <NoRowsDeallocation batchName={batchName} />
        }}
        // onRowClick={() => console.log('row')}
        isRowSelectable={isRowSelectable}
        disableSelectionOnClick
        selectionModel={selectionModel}
        onSelectionModelChange={(newSelectionModel) => {
          // if (newSelectionModel.length > availableForSelection) {
          //   setSelectionModel(newSelectionModel.slice(0, availableForSelection))
          //   return;
          // }
          setSelectionModel(newSelectionModel)
        }}
        rowCount={rowCount}
        rowBuffer={10}
        hideFooterSelectedRowCount={true}
        sx={{
          color: '#262626',
          fontFamily: 'inherit',
          '.MuiDataGrid-cell:focus-within, .MuiDataGrid-cell:focus, .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-columnHeader:focus': {
            outline: 'none'
          },
          '.MuiDataGrid-cell--editing:focus-within, .MuiDataGrid-cell--editing:focus, .MuiDataGrid-cell--editing:focus-visible': {
            outline: 'none !important',
          },
        }}
      />
      {selectionModel.length > 0 &&
        <MultiSelectFooter
          selectionModel={selectionModel}
          setSelectionModel={setSelectionModel}
          setIsMultiDeallocate={setIsMultiDeallocate}
          setOpenDeallocationDialog={setOpenDeallocationDialog}
        />
      }
      <ConfirmationDialog
        open={openDeallocationDialog}
        setOpen={setOpenDeallocationDialog}
        id={studentId}
        deallocateStudentHandler={deallocateStudentHandler}
        isMulti={isMultiDeallocate}
        selectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
      />
    </div>
  )
}

export default StudentList